export default "__VITE_ASSET__hXXNdQXR__"